var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonoutlinewhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00002 2.6665C6.52669 2.6665 5.33335 3.85984 5.33335 5.33317C5.33335 6.8065 6.52669 7.99984 8.00002 7.99984C9.47335 7.99984 10.6667 6.8065 10.6667 5.33317C10.6667 3.85984 9.47335 2.6665 8.00002 2.6665ZM9.33335 5.33317C9.33335 4.59984 8.73335 3.99984 8.00002 3.99984C7.26669 3.99984 6.66669 4.59984 6.66669 5.33317C6.66669 6.0665 7.26669 6.6665 8.00002 6.6665C8.73335 6.6665 9.33335 6.0665 9.33335 5.33317ZM12 11.3332C11.8667 10.8598 9.80002 9.99984 8.00002 9.99984C6.20002 9.99984 4.13335 10.8598 4.00002 11.3398V11.9998H12V11.3332ZM2.66669 11.3332C2.66669 9.55984 6.22002 8.6665 8.00002 8.6665C9.78002 8.6665 13.3334 9.55984 13.3334 11.3332V13.3332H2.66669V11.3332Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonoutlinewhite);
export default __webpack_public_path__ + "static/media/personoutlinewhite.f785bc2248b6eac9b14a57ae91675bd0.svg";
export { ForwardRef as ReactComponent };